"use client";

import { useState } from "react";
import * as Container from "@repo/ui/container";
import { DynamicHeight } from "@repo/ui/dynamic-height";
import { Gallery } from "@repo/ui/gallery";
import * as Viewport from "@/components/viewport";
import { COLLAGE } from "@/constants";
import { FullWidthGallery } from "../full-width-gallery";

type GalleryProps = {
  productImages: string[];
  productName: string;
  videoUrls: {
    mobile: string;
    desktop: string;
  };
};

export const GalleryPane = ({
  productImages,
  productName,
  videoUrls,
}: GalleryProps) => {
  const [isFullWidthGalleryOpen, setIsFullWidthGalleryOpen] = useState(false);
  const [defaultImageIndex, setDefaultImageIndex] = useState(1);
  const desktopWidthAsVw = 56;
  const aspectRatio = 0.79;
  const desktopColumns = 2;

  const productImagesWithVideo = videoUrls.mobile
    ? [...productImages.slice(0, 1), "video", ...productImages.slice(1)]
    : productImages;

  return (
    <div>
      <Viewport.Small>
        <Container.Break>
          <DynamicHeight>
            <Gallery
              productImages={productImages}
              productName={productName}
              videoUrl={videoUrls.mobile}
              sourceSetProfile={COLLAGE}
              sourceSetSizes="100vw"
              itemAspectRatio={aspectRatio}
              aspectRatio="auto"
              zoomImages={true}
              scrollDirection="vertical"
              showScrollIndicators={true}
              indicatorAxis="y"
              indicatorPosition="start"
            />
          </DynamicHeight>
        </Container.Break>
      </Viewport.Small>

      <Viewport.Large>
        <Gallery
          productImages={productImages}
          productName={productName}
          videoUrl={videoUrls.desktop}
          autoPlayVideos
          sourceSetProfile={COLLAGE}
          sourceSetSizes={`${desktopWidthAsVw / desktopColumns}vw`}
          itemAspectRatio={aspectRatio}
          onImageClick={(index) => {
            setDefaultImageIndex(index);
            setIsFullWidthGalleryOpen(true);
          }}
          zoomImages={false}
          columns={2}
        />
      </Viewport.Large>
      {isFullWidthGalleryOpen && (
        <FullWidthGallery
          productImagesWithVideo={productImagesWithVideo}
          videoUrls={videoUrls}
          productName={productName}
          onClose={() => setIsFullWidthGalleryOpen(false)}
          defaultImageIndex={defaultImageIndex}
        />
      )}
    </div>
  );
};
